__turbopack_context__.v({
  "clickableText": "i1mg1q_clickableText",
  "wrapper": "i1mg1q_wrapper",
});
